import { gql } from '@apollo/client';
import { TaskType } from '../../types';

export const GET_SHIP_FROM_HERE_TASK_LIST = gql`
    query GetShipFromHereTaskList($filter: TmsTaskFiltersInput, $pageRequest: PageRequestTypeInput) {
        getShipFromHereTaskList(filters: $filter, pageRequest: $pageRequest) {
            content {
                id
                taskNumber
                taskType
                businessType
                taskDate
                taskStatus
                routeId
                routeName
                routeCode
                routeType
                carrierSourceType
                warehouseId
                planDepartureDate
                planDepartureTime
                planDepartureAt
                planDepartureTimezone
                actualDepartureDate
                actualDepartureTime
                actualDepartureAt
                actualDepartureTimezone
                planArrivalDate
                planArrivalTime
                planArrivalAt
                planArrivalTimezone
                actualArrivalDate
                actualArrivalTime
                actualArrivalAt
                actualArrivalTimezone
                originTimezone
                destinationTimezone
                vehicleEstimatedArrivalDate
                vehicleEstimatedArrivalTime
                vehicleEstimatedArrivalAt
                vehicleEstimatedArrivalTimezone
                currentStation
                currentWaypointStatus
                carrierId
                carrierName
                driverId
                driverName
                vehicleId
                licensePlate
                vehicleModel
                vehicleTypeId
                vehicleTypeName
                escortCount
                gpsTracking
                bolNumber
                perVehicleCost
                remark
                updatedAt
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface TmsTaskType extends TaskType {}

export interface ShipFromHereTaskType extends TaskType {}

export interface TmsTaskFiltersInput {
    taskType?: number;
    businessType?: number;
    routeId?: number;
    routeCode?: string;
    taskNumber?: string;
    taskStatus?: number;
    taskStatuses?: number[];
    routeType?: number;
    scheduleId?: number;
    carrierId?: number;
    driverId?: number;
    vehicleId?: number;
    driverName?: string;
    licensePlate?: string;
    warehouseId?: number;
    taskDateStart?: string;
    taskDateEnd?: string;
    // 发车时间（实际发车）区间，ISO-8601 UTC
    departureTimeStart?: string;
    departureTimeEnd?: string;
}

export interface TmsTaskListingResponse {
    getShipFromHereTaskList: TmsTaskListingResponseType;
}

export interface TmsTaskListingResponseType {
    content: TmsTaskType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

